/* eslint-disable @typescript-eslint/no-explicit-any */
import { RequestError } from '@requests/common';
import { listModules } from '@requests/flow';
import { FlowModule } from '@store/async';
import { useQuery } from '@tanstack/react-query';
import { useParams } from 'react-router-dom';

export type WorkflowModule = {
  flow_id: string;
  name: string;
  service_id: string;
  description: string;
};

export const useModules = () => {
  const { service_id, workflow_id } = useParams();

  const { data, error } = useQuery<FlowModule[], RequestError, FlowModule[], [string, string | undefined]>({
    queryKey: ['modules', service_id],
    queryFn: listModules,
  });

  const modules = Array.isArray(data) ? data : [];
  const errorMessage = error?.response?.data?.error || error?.message;

  return {
    modules: modules?.filter((mod: FlowModule) => mod.flow_id !== workflow_id),
    allModules: modules,
    error: errorMessage,
  };
};
